export function maybeGetSectionForOption(context, type) {
    return undefined;
}
